import environment from 'environment';

export const services = {
  authenticationCenter: `${environment.serviceHostName}/authentication-center`,
  authorizationEMarketplace: `${environment.serviceHostName}/authorize-emarketplace`,
  eMarketplace: `${environment.serviceHostName}/emarketplace`,
  integration: `${environment.serviceHostName}/integration`,
  product: `${environment.serviceHostName}/product`,
  eventHandler: `${environment.eventHostName}/event-handler`,
  graphqlGateway: `${environment.serviceHostName}/graphql`,
  report: `${environment.serviceHostName}/report`,
  payment: `${environment.serviceHostName}/payment`,
  pi: `${environment.serviceHostName}/pi`,
  eMarketplaceCategoryProduct: `${environment.productHostName}/api/v1/product/attribute`,
};

const APIConstant = {
  accountURL: `${environment.accountFrontend}/login`,
  eMarketplaceLogin: `${environment.eMarketplaceFrontend}/login`,
  logout: `${services.authenticationCenter}/api/v1/logout?redirect_uri=${environment.eMarketplaceFrontend}/login`,
  redirectURL: `${environment.eMarketplaceFrontend}/redirect`,
  publicKey: `${environment.publicKey}`,
  authenticationCenterService: {
    accountLoginPageURL: `${environment.keycloakHostName}/auth/realms/${environment.keycloakRealm}/protocol/openid-connect/auth`,
    accountGetAccessTokenURL: `${services.authenticationCenter}/api/v1/token`,
    accountRealmInformationURL: `${environment.keycloakHostName}/auth/realms/${environment.keycloakRealm}`,
    accountRenewAccessTokenURL: `${services.authenticationCenter}/api/v1/oauth/token`,
  },
  authorizationEMarketplace: {
    getMyProfile: `${services.authorizationEMarketplace}/api/v1/profile`,
    getPermission: `${services.authorizationEMarketplace}/api/v1/permission`,
    getSubscriptionPlan: `${services.authorizationEMarketplace}/api/v1/subscription`,
    getSubscriptionPackageSetting: `${services.authorizationEMarketplace}/api/v1/subscription/package-setting`,
    postPricePlan: `${services.authorizationEMarketplace}/api/v1/subscription/request`,
    userInCompanyList: `${services.authorizationEMarketplace}/api/v1/user/list`,
    addUser: `${services.authorizationEMarketplace}/api/v1/user`,
    deleteUser: `${services.authorizationEMarketplace}/api/v1/user`,
    getSubscriptionData: `${services.authorizationEMarketplace}/api/v1/subscription/company/{companyID}`,
    getConentReadOnly: `${services.authorizationEMarketplace}/api/v1/consent`,
    getUserConsent: `${services.authorizationEMarketplace}/api/v1/consent/user`,
    acceptUserConsent: `${services.authorizationEMarketplace}/api/v1/consent/accept`,
    getPackageList: `${services.authorizationEMarketplace}/api/v1/package/list`,
    getSupplierPackageList: `${services.authorizationEMarketplace}/api/v1/supplier/package/list`,
    searchSupplierUser: `${services.authorizationEMarketplace}/api/v1/supplier/{companyID}/users`,
    addAllSupplierUser: `${services.authorizationEMarketplace}/api/v1/user/all`,
    getMaintenanceDetail: `${services.authorizationEMarketplace}/api/v1/maintenance-detail`,
    resubmitDocument: `${services.authorizationEMarketplace}/api/v1//document/resubmit`,
    getSubscriptionInformation: `${services.authorizationEMarketplace}/api/v1/subscription/{subscriptionID}/information`,
    getResponseDocumentHistory: `${services.authorizationEMarketplace}/api/v1/supplier/subscription/{subscriptionID}/document/log`,
    postUpgradeSubscriptionPlan: `${services.authorizationEMarketplace}/api/v1/upgrade/subscription/package`,
    downloadConsentTemplate: `${services.authorizationEMarketplace}/api/v1/consent/template`,
    getConsentSupplier: `${services.authorizationEMarketplace}/api/v1/consent-supplier`,
  },
  eventHandler: {
    authorization: `${services.eventHandler}/api/v1/auth`,
    listeningProductCartEvent: `${services.eventHandler}/api/v1/emarketplace/cart/product?code={authCode}`,
    listeningSupplierCartEvent: `${services.eventHandler}/api/v1/emarketplace/cart/supplier?code={authCode}`,
  },
  eMarketplace: {
    getBuyerCompany: `${services.eMarketplace}/api/v1/buyer/{companyID}/detail`,
    getJobBoardList: `${services.eMarketplace}/api/v1/buyer/{companyID}/job/list`,
    getCategory: `${services.eMarketplace}/api/v1/category?search={search}`,
    getCategories: `${services.pi}/api/v1/categories?search={search}`,
    postBuyingLead: `${services.eMarketplace}/api/v1/buyer/{companyID}/job`,
    getBuyerJobDetail: `${services.eMarketplace}/api/v1/buyer/{companyID}/job/{jobID}`,
    getBuyerJobDetailHistory: `${services.eMarketplace}/api/v1/buyer/{companyID}/job/{jobID}/history`,
    getSupplierJobDetailHistory: `${services.eMarketplace}/api/v1/supplier/{supplierID}/branch/{branchID}/job/{jobID}/history`,
    editJobConversationAllowance: `${services.eMarketplace}/api/v1/buyer/{companyID}/job/{jobID}/conversation`,
    postBuyerConversation: `${services.eMarketplace}/api/v1/buyer/{companyID}/job/{jobID}/{conversationType}/conversation`,
    editBuyerConversation: `${services.eMarketplace}/api/v1/buyer/{companyID}/job/{jobID}/{conversationType}`,
    postSupplierConversation: `${services.eMarketplace}/api/v1/supplier/{supplierID}/branch/{branchID}/job/{jobID}/{conversationType}/conversation`,
    editSupplierConversation: `${services.eMarketplace}/api/v1/supplier/{supplierID}/branch/{branchID}/job/{jobID}/{conversationType}`,
    getAdminConversationHistory: `${services.eMarketplace}/api/v1/admin/job/{jobID}/{conversationType}`,
    getBuyerJobConversation: `${services.eMarketplace}/api/v1/buyer/{companyID}/job/{jobID}/conversation`,
    getSupplierJobConversation: `${services.eMarketplace}/api/v1/supplier/{supplierID}/branch/{branchID}/job/{jobID}/conversation`,
    downloadBuyerConversationAttachment: `${services.eMarketplace}/api/v1/buyer/{companyID}/conversation/{conversationType}/attachment/{attachmentID}`,
    downloadSupplierConversationAttachment: `${services.eMarketplace}/api/v1/supplier/{supplier}/branch/{branchID}/conversation/{conversationType}/attachment/{attachmentID}`,
    downloadAdminConversationAttachment: `${services.eMarketplace}/api/v1/admin/conversation/{conversationType}/attachment/{attachmentID}`,
    cancelBuyingLead: `${services.eMarketplace}/api/v1/buyer/{companyID}/job/{jobID}/cancel`,
    getBuyerJobDetailByERFxNo: `${services.eMarketplace}/api/v1/erfx/{erfxNo}/buyer/{companyID}/job`,
    downloadJobAttachment: `${services.eMarketplace}/api/v1/job/{jobID}/attachment/{attachmentID}`,
    downloadJobResponseAttachment: `${services.eMarketplace}/api/v1/job-response/{jobResponseID}/attachment/{attachmentID}`,
    getSupplierJobBoardList: `${services.eMarketplace}/api/v1/supplier/{companyID}/branch/{branchID}/job/list`,
    getSupplierJobDetail: `${services.eMarketplace}/api/v1/supplier/{supplierID}/branch/{branchID}/job/{jobID}`,
    postQuote: `${services.eMarketplace}/api/v1/supplier/{supplierID}/branch/{branchID}/job/{jobID}/quote`,
    getSupplierBuyerList: `${services.eMarketplace}/api/v1/supplier/{supplierID}/buyer-list`,
    getSubCompanyList: `${services.eMarketplace}/api/v1/company/{companyID}/sub-companies`,
    getBuyerSubCompany: `${services.eMarketplace}/api/v1/company/{companyID}/my-sub-company`,
    createRFQ: `${services.eMarketplace}/api/v1/buyer/erfx/rfq`,
    getErfxBtn: `${services.eMarketplace}/api/v1/features`,
    productDetail: `${services.eMarketplace}/api/v1/product/{productID}?currencyCode={currencyCode}`,
    productDetailCartItemByProductId: `${services.eMarketplace}/api/v1/product/{productID}/cart/item`,
    productDetailCartItem: `${services.eMarketplace}/api/v1/product/cart/item`,
    supplierInfo: `${services.eMarketplace}/api/v1/supplier/{companyID}/branch/{branchID}`,
    productCart: `${services.eMarketplace}/api/v1/product/cart`,
    getSupplierCart: `${services.eMarketplace}/api/v1/supplier/cart`,
    supplierCartItem: `${services.eMarketplace}/api/v1/supplier/cart/item`,
    verifySupplierCart: `${services.eMarketplace}/api/v1/supplier/verify`,
    createProductQuotation: `${services.eMarketplace}/api/v1/product/erfx`,
    updateProductQuotation: `${services.eMarketplace}/api/v1/product/erfx/update`,
    createSupplierQuotation: `${services.eMarketplace}/api/v1/supplier/erfx`,
    updateSupplierQuotation: `${services.eMarketplace}/api/v1/supplier/erfx/update`,
    cartAmount: `${services.eMarketplace}/api/v1/user/cart/amount`,
    supplierResponses: `${services.eMarketplace}/api/v1/supplier/{supplierID}/branch/{branchID}/responses`,
    supplierResponsesByUser: `${services.eMarketplace}/api/v1/buyer/{companyID}/supplier/{supplierID}/branch/{branchID}/user/{userID}/responses`,
    supplierResponsesBuyer: `${services.eMarketplace}/api/v1/buyer/{companyID}/job/{jobID}/supplier-respond/list`,
    supplierProductShowCase: `${services.eMarketplace}/api/v1/supplier/product/showcase`,
    supplierRecommendJobCategory: `${services.eMarketplace}/api/v1/supplier/{supplierID}/branch/{branchID}/recommend/category`,
    shippingArea: `${services.eMarketplace}/api/v1/shipping-area`,
    estimatedProjectValue: `${services.eMarketplace}/api/v1/estimated-project-value`,
    getStateListSupplierJobBoardList: `${services.eMarketplace}/api/v1/supplier/{supplierID}/branch/{branchID}/job/state`,
    getStateListBuyerJobBoardList: `${services.eMarketplace}/api/v1/buyer/{companyID}/job/state`,
    verifySupplier: `${services.eMarketplace}/api/v1/erfx/{erfxNo}/supplier/{supplierID}/branch/{branchID}/verify`,
    easyQuoteverifySupplier: `${services.eMarketplace}/api/v1/job/{jobID}/supplier/{supplierID}/branch/{branchID}/verify`,
    exportSupplierTransactionReport: `${services.eMarketplace}/api/v1/supplier/{supplierID}/report/supplier-transaction`,
    buyerSaveJobFavorite: `${services.eMarketplace}/api/v1/buyer/{companyID}/job/{jobID}/favorite`,
    supplierSaveJobFavorite: `${services.eMarketplace}/api/v1/supplier/{supplierID}/branch/{branchID}/job/{jobID}/favorite`,
    tutorial: `${services.eMarketplace}/api/v1/tutorial`,
    getAddingBuyingLeadItemUOM: `${services.eMarketplace}/api/v1/buyer/{companyID}/uom-list`,
    downloadJobItemData: `${services.eMarketplace}/api/v1/buyer/{companyID}/job-items/template`,
    uploadJobItemData: `${services.eMarketplace}/api/v1/buyer/{companyID}/job-items`,
    getjobSupplierRespondedHistoryBuyer: `${services.eMarketplace}/api/v1/buyer/{companyID}/supplier-responded/history`,
    getjobSupplierRespondedHistorySupplier: `${services.eMarketplace}/api/v1/supplier/{supplierID}/branch/{branchID}/supplier-responded/history`,
    updateBuyingLeadsPeriod: `${services.eMarketplace}/api/v1/buyer/{companyID}/job/{jobID}/period`,
    supplierEvent: `${services.eMarketplace}/api/v1/supplier/{supplierID}/branch/{branchID}/event-tracking/{event}`,
    buyerEvent: `${services.eMarketplace}/api/v1/buyer/{companyID}/event-tracking/{event}/{itemType}`,

    // Admin Role
    getAdminJobBoardList: `${services.eMarketplace}/api/v1/admin/job/list`,
    getAdminJobDetail: `${services.eMarketplace}/api/v1/admin/job/{jobID}`,
    getAdminJobDetailHistory: `${services.eMarketplace}/api/v1/admin/job/{jobID}/history`,
    getAdminSupplierResponses: `${services.eMarketplace}/api/v1/admin/job/{jobID}/supplier-respond/list`,
    getAdminSupplierResponsesByUser: `${services.eMarketplace}/api/v1/admin/supplier/{supplierID}/branch/{branchID}/user/{userID}/responses`,
    getAdminJobConversation: `${services.eMarketplace}/api/v1/admin/job/{jobID}/conversation`,
    getjobSupplierRespondedHistoryAdmin: `${services.eMarketplace}/api/v1/admin/supplier-responded/history`,

    // Tracking User Data
    trackBuyerSearchingEvent: `${services.eMarketplace}/api/v1/buyer/{companyID}/event-tracking/searching`,
  },
  report: {
    exportBuyingLeads: `${services.report}/api/v1/company/{companyID}/job/{jobID}/report/buying-lead-detail`,
  },
  integration: {
    getAuthCode: `${services.integration}/api/v1/uaa/tenant/{tenantID}/auth/code`,
  },
  erfx: {
    detail: `${environment.erfxFrontend}/ERFX2/login/CommonLogin.action?authCode={res.data.authCode}&erfx_id={erfxNo}&SelectService={service}`,
    proceedToERFX: `${environment.erfxFrontend}/ERFX2/login/CommonLogin.action?authCode={res.data.authCode}&erfx_id={erfxNo}&SelectService=clb_proceed_to_erfx`,
    detail2: `${environment.erfxFrontend}/ERFX2/login/CommonLogin.action?authCode={res.data.authCode}&erfx_id={erfxNo}&SelectService=clb_erfx_adjustment_detail&subSelectService={subService}`,
    responseScreen: `${environment.erfxFrontend}/ERFX2/sp/SupplierCommonLogin.action?erfx_id={erfxNo}&PageID=2&authCode={res.data.authCode}`,
    historyScreen: `${environment.erfxFrontend}/ERFX2/sp/SupplierCommonLogin.action?erfx_id={erfxNo}&PageID=3&authCode={res.data.authCode}`,
  },
  product: {
    eMarketplaceProductList: `${services.product}/api/v1/emarketplace/product/list`,
    eMarketplaceSupplierList: `${services.product}/api/v1/emarketplace/supplier/list`,
    getProductListFilterData: `${services.product}/api/v1/emarketplace/product/list/filter?search={searchKeyword}&searchBy={searchBy}&companyID={supplierID}&branchID={branchID}&displayBy={displayBy}&currencyCode={currencyCode}`,
    eMarketplaceRecommendPromotionProductList: `${services.product}/api/v1/emarketplace/recommend/promotion/product/list`,
    eMarketplaceSupplierRecommendPromotionProductList: `${services.product}/api/v1/emarketplace/supplier/recommend/promotion/product/list`,
    eMarketplaceRecommendNewInProductList: `${services.product}/api/v1/emarketplace/recommend/new-in/product/list`,
    eMarketplaceSupplierRecommendNewInProductList: `${services.product}/api/v1/emarketplace/supplier/recommend/new-in/product/list`,
  },
  pi: {
    getCompanyProfile: `${environment.serviceHostName}/company-v2/api/v1/company`,
    piSearch: `${services.pi}/api/v1/product/pi`,
    piSearchList: `${services.pi}/api/v1/product/list`,
    piDetailBuyerList: `${services.pi}/api/v1/product/buyerBranches`,
    piDetailProductOverview: `${services.pi}/api/v1/product/overview`,
    piDetailPriceMovingAverage: `${services.pi}/api/v1/product/price-moving-average`,
    piDetailPriceMovingAverageCommodity: `${services.pi}/api/v1/ai/multivariate-forecast`,
    piDetailSubstitutionProduct: `${services.pi}/api/v1/product/substitution`,
    piDetailTrendingProduct: `${services.pi}/api/v1/product/hot-trend`,
    piDetailSuggestedSupplier: `${services.pi}/api/v1/product/supplier/substitution`,
    piSupplierDetailBuyerList: `${services.pi}/api/v1/supplier/product/buyerBranches`,
    piSupplierDetail: `${services.pi}/api/v1/product/supplier`,
    piCategory: `${services.pi}/api/v1/category`,
    piPoDetail: `${services.pi}/api/v1/product/buyerBranches/poDetails`,
    piBookmark: `${services.pi}/api/v1/user/bookmark`,
    piCart: `${services.pi}/api/v1/user/cart`,
    piCartList: `${services.pi}/api/v1/user/cart/list`,
    piCompare: `${services.pi}/api/v1/product/compare`,
    piDraftPR: `${services.pi}/api/v1/user/draft-pr`,
    piPermission: `${services.pi}/api/v1/ep/user`,
    piPopularProducts: `${services.pi}/api/v1/supplier/product/popular`,
    piSupplierDetailtOverview: `${services.pi}/api/v1/supplier/product/overview`,
    piDetailCompetitors: `${services.pi}/api/v1/supplier/product/losing-product`,
    piViewerCount: `${services.pi}/api/v1/viewer/collect`,
    piVisitorCount: `${services.pi}/api/v1/visitor/collect`,
    piBookmarkCount: `${services.pi}/api/v1/bookmark/collect`,
    piAddToCartCount: `${services.pi}/api/v1/cart/collect`,
    piProfileDraftPR: `${services.pi}/api/v1/supplier/performance`,
    piDataDraftPRChart: `${services.pi}/api/v1/supplier/performance/draftPR`,
    piPerformanceScore: `${services.pi}/api/v1/supplier/scores`,
    piDetailCatalog: `${services.pi}/api/v1/catalog`,
    getProductList: `${environment.storeManagement}`,
    piTopSale: `${services.pi}/api/v1/product/summary/top`,
    getTrendingSearchList: `${services.pi}/api/v1/top-search`,
    getItemsForTrendingSearchKey: `${services.pi}/api/v1/keyword-info`,
    getSupplierOfferingBoardFilterList: `${services.pi}/api/v1/supplier/{companyID}/branch/{branchID}/offering/list`,
    getBuyerOfferingBoardFilterList: `${services.pi}/api/v1/buyer/{companyID}/offering/list`,
    postOfferingBoard: `${services.pi}/api/v1/offering`,
    getBuyerNotifyList: `${services.pi}/api/v1/buyer/tenantCompanyMapping`,
    getOfferingBoard: `${services.pi}/api/v1/supplier/{companyID}/branch/{branchID}/offering/{offeringID}`,
    getBuyerOfferingBoard: `${services.pi}/api/v1/buyer/{companyID}/offering/{offeringID}`,
    updateOfferingStatus: `${services.pi}/api/v1/offering/status/{offeringID}`,
    postAcceptOffering: `${services.pi}/api/v1/offering/{offeringID}/buyer/{companyID}/accept`,
    getBuyerResponseList: `${services.pi}/api/v1/offering/{offeringID}/buyerResponse`,
    postSellerConversation: `${services.pi}/api/v1/offering/{offeringID}/supplier/{companyID}/branch/{branchID}/post/conversation`,
    editPostSellerConversation: `${services.pi}/api/v1/offering/{offeringID}/supplier/{companyID}/branch/{branchID}/post/conversation/{conversationID}`,
    cancelPostSellerConversation: `${services.pi}/api/v1/offering/{offeringID}/supplier/{companyID}/branch/{branchID}/post/conversation/{conversationID}/cancel`,
    postBuyerConversation: `${services.pi}/api/v1/offering/{offeringID}/buyer/{companyID}/post/conversation`,
    editPostBuyerConversation: `${services.pi}/api/v1/offering/{offeringID}/buyer/{companyID}/post/conversation/{conversationID}`,
    cancelPostBuyerConversation: `${services.pi}/api/v1/offering/{offeringID}/buyer/{companyID}/post/conversation/{conversationID}/cancel`,
    getSellerConversation: `${services.pi}/api/v1/offering/{offeringID}/supplier/{companyID}/branch/{branchID}/conversation`,
    getBuyerConversation: `${services.pi}/api/v1/offering/{offeringID}/buyer/{companyID}/conversation`,
    replySellerConversation: `${services.pi}/api/v1/offering/{offeringID}/supplier/{companyID}/branch/{branchID}/reply/conversation/{conversationID}`,
    editReplySellerConversation: `${services.pi}/api/v1/offering/{offeringID}/supplier/{companyID}/branch/{branchID}/reply/{replyID}/conversation/{conversationID}`,
    cancelReplySellerConversation: `${services.pi}/api/v1/offering/{offeringID}/supplier/{companyID}/branch/{branchID}/reply/{replyID}/conversation/{conversationID}/cancel`,
    replyBuyerConversation: `${services.pi}/api/v1/offering/{offeringID}/buyer/{companyID}/reply/conversation/{conversationID}`,
    editReplyBuyerConversation: `${services.pi}/api/v1/offering/{offeringID}/buyer/{companyID}/reply/{replyID}/conversation/{conversationID}`,
    cancelReplyBuyerConversation: `${services.pi}/api/v1/offering/{offeringID}/buyer/{companyID}/reply/{replyID}/conversation/{conversationID}/cancel`,
    sellerDownloadAttachment: `${services.pi}/api/v1/offering/{offeringID}/supplier/{companyID}/branch/{branchID}/conversation/{conversationType}/attachment/{attachmentID}`,
    buyerDownloadAttachment: `${services.pi}/api/v1/offering/{offeringID}/buyer/{companyID}/conversation/{conversationType}/attachment/{attachmentID}`,
    readOfferingBoardConversation: `${services.pi}/api/v1/offering/{offeringID}/read`,
  },
  supplierConnect: {
    redirect: `${environment.supplierConnectFrontend}`,
    mainPage: `${environment.supplierConnectFrontend}/company-management`,
    createProduct: `${environment.supplierConnectFrontend}/product/add`,
  },
  payment: {
    uploadSubscriptionAttachment: `${services.payment}/api/v1/subscription/attachment`,
    downloadAttachment: `${services.payment}/api/v1/subscription/attachment`,
  },
  graphQLGateway: `${services.graphqlGateway}`,
  ep: {
    redirect: `${environment.epFrontend}/LoginPage.action`,
  },
  oneplanet: {
    redirect: `${environment.onePlanetFrontend}`,
  },
  admin: {
    redirect: `${environment.adminFrontend}`,
  },
  cookieAgent: {
    setCookie: `${environment.cookieAgent}/?cookie={cookie}&path={redirectUrl}`,
  },
};

export default APIConstant;
